import { useState, useEffect } from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@mui/material';
import {
  Dashboard,
  AccessTime,
  BeachAccess,
  Receipt,
  Menu as MenuIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePermissions } from '../../context/PermissionContext';

function BottomNavigationComponent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const [value, setValue] = useState(0);

  // Map paths to navigation values
  const pathToValue = {
    '/': 0,
    '/attendance': 1,
    '/leave': 2,
    '/payslips': 3,
  };

  useEffect(() => {
    const currentValue = pathToValue[location.pathname];
    if (currentValue !== undefined) {
      setValue(currentValue);
    }
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const paths = ['/', '/attendance', '/leave', '/payslips'];
    navigate(paths[newValue]);
  };

  // Build navigation items based on permissions
  const navItems = [
    {
      label: 'Dashboard',
      icon: <Dashboard />,
      value: 0,
      permission: null,
    },
    {
      label: 'Attendance',
      icon: <AccessTime />,
      value: 1,
      permission: 'attendance:view',
    },
    {
      label: 'Leave',
      icon: <BeachAccess />,
      value: 2,
      permission: 'leave:view',
    },
    {
      label: 'Payslips',
      icon: <Receipt />,
      value: 3,
      permission: 'payroll:view_own',
    },
  ];

  const visibleItems = navItems.filter(
    (item) => !item.permission || hasPermission(item.permission)
  );

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar,
      }}
      elevation={3}
    >
      <BottomNavigation value={value} onChange={handleChange} showLabels>
        {visibleItems.map((item) => (
          <BottomNavigationAction
            key={item.value}
            label={item.label}
            icon={item.icon}
            value={item.value}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}

export default BottomNavigationComponent;
